import Cookies from 'cookies-js'
import Storage from './storage'

// var options = { 
//   domain: pageDomain()
// };

// function clearDeprecatedCookies() {
//   var cookies = document.cookie.split(";");

//   for (var i = 0, len = cookies.length; i < len; i++) {
//     var cookie = cookies[i];
//     var eqPos = cookie.indexOf("=");
//     var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
//     document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; Domain=www.sfj.com; path=/";
//   }
// }

// function pageDomain() {
//   var domain = window.location.hostname;
//   if (!/^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})|localhost$/.test(domain)) {
//     var match = /^(?:[^\/\?:\.]+\.)*([^\/\?:\.]+\.[^\/\?:\.]+)$/.exec(domain);
//     domain = '.' + match[1];
//   }
//   return domain;
// }

// function setCookies(key, value) {
//   // Cookies.set(key, value, options)  //正式服
//   Cookies.set(key, value)           //测试服 && 本地
// }

// function getCookies(key) {
//   return Cookies.get(key)
// }

// function delCookies(key) {
//   Cookies.expire(key, options)
// }

// export function setName (name) {
//   if (!name) {
//     delCookies('name')
//   } else {
//     setCookies('name', name)
//   }
// }

// export function getName () {
//   return getCookies('name')
// }

export function setToken(token) {
  if (token) {
    Storage.set('qk_web_token',token)
  } else {
    Storage.remove('qk_web_token')
  }
}

export function getToken () {
  let uToken = Storage.get('qk_web_token')

  if (!uToken) {
    uToken = false
  }

  return uToken
}

export function setUserInfo (userInfo) {
  if (!userInfo || JSON.stringify(userInfo) === '{}') {
    Storage.remove('userInfo')
    // Storage.remove('avatar')
  } else {
    Storage.set('userInfo', userInfo)
    // Storage.set('avatar', userInfo.avatar.o)
  }
}

export function getUserInfo () {
  let uInfo = Storage.get('userInfo')
  if (!uInfo) {
    uInfo = false
  }
  
  return uInfo
}

export function setIsPopThirdBindWindow(alreadyPop) {
  if (alreadyPop) {
    Storage.set('alreadyPop', alreadyPop)
  } else {
    Storage.remove('alreadyPop')
  }
}

export function getIsPopThirdBindWindow() {
  return Storage.get('alreadyPop');
}

export function setSearchHistory(historyList) {
  Storage.set('searchHistory', historyList)
}

export function removeSearchHistory() {
  Storage.remove('searchHistory')
}

export function getSearchHistory() {
  return Storage.get('searchHistory');
}

export function setLocalPublicKey(keyInfo) {
  Storage.set('localPublicKey',keyInfo)
}

export function getLocalPublicKey() {
  return Storage.get('localPublicKey') || null
}



// WEBPACK FOOTER //
// ./src/utils/auth.js